export default __webpack_public_path__ + "locales/el-GR/Payments.json?hash=e9dc00eb2dae6138212dd93acd20b5c5";